import { gql } from '@/__generated__';

const GET_CHART_PREVIEW_DATA = gql(`#graphql
  query MathModeling_GetChartPreviewData($input: DevicesInput!, $metricsInput: MetricsParametersInput) {
    devices(input: $input) {
      id
      metrics(input: $metricsInput) {
        id
        flow {
          data
          unit
          precision
        }
        level {
          data
          unit
          precision
        }
        velocity {
          data
          unit
          precision
        }
        position {
          data
          unit
          precision
        }
        angle {
          data
          unit
          precision
        }
      }
    }
  }
`);

export default GET_CHART_PREVIEW_DATA;
